import axios from 'axios'
import urls from './urls'
import store from '../../store'
import querystring from 'querystring'

const verifyEmail = async function ({ email }) {
  try {
    let data = {
      email
    }
    let parameterizedUrl = urls.emailVerification + '?' + querystring.stringify(data)
    const res = await axios.get(parameterizedUrl)
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

const activateAccount = async function ({ email, username, password }) {
  try {
    let data = {
      email,
      username,
      password,
      'fcm': store.state.user.fcmToken,
      version: 'v2'
    }
    const res = await axios.post(urls.accountActivation, data)
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

export {
  verifyEmail,
  activateAccount
}
